/**
 * @copyright The Converse.js contributors
 * @license Mozilla Public License (MPLv2)
 */

import { _converse, api, converse } from '@converse/headless/core';
import {html} from "lit";
import RoomsListModel from '../roomslist/model.js';
import {initStorage} from "@converse/headless/utils/storage";

converse.plugins.add('converse-altelis', {

    dependencies: ["converse-status", "converse-modal", "converse-vcard", "converse-chatboxviews"],

    initialize: function () {
        // const t = _converse.api.settings.get("reticular_i18n")

        window._converse = this._converse;
        initializeShowMessageOption();
        this._converse.reticular = {
            sharePost, mention, closeChat, openLastChat, forceRosterRefresh
        }

        //https://m.conversejs.org/docs/html/api/shared_rich-text.js.html#line146
        _converse.api.listen.on('afterMessageBodyTransformed', function (richText) {
            parseLinkReticularMessage(richText);
        });
        //checkUnreadMessage on Init
        checkNotification();
        setLastOpen(null);

        _converse.api.listen.on('messageNotification', function (data) {
            checkNotification();
        });
        api.waitUntil('chatBoxesInitialized').then(() => {
            _converse.chatboxes.on('change:num_unread', checkNotification);
            checkNotification();
            closeChat();
        });

        //_converse.api.listen.on('initialized', () => forceRosterRefresh(true));
        _converse.api.listen.on('rosterInitialized', () => forceRosterRefresh(true));
        _converse.api.listen.on('rosterReadyAfterReconnection', () => forceRosterRefresh(true));


        function checkNotification() {
            let countRoom = 0;
            let countConversation = 0;
            if(_converse.chatboxes){
                const rooms = _converse.chatboxes.filter(m => m.get('type') === _converse.CHATROOMS_TYPE);
                rooms.forEach(room => {
                    console.log("room",room);
                    console.log("nnn",room.get('num_unread'));
                    countRoom += room.get('num_unread');
                });
            }


            _converse.api.contacts.get().then((data) => {

                const unread = data.map((item) => item.get('num_unread')).filter((number) => number > 0);

                const IMElements = document.querySelectorAll('.IM');
                console.log("unread",unread);
                if (unread.length > 0) {
                    const unreadCount = unread.reduce((a, b) => a + b, 0);
                    countConversation = unreadCount;
                    IMElements.forEach((IMElement) => {
                        console.log("IMElement",IMElement);
                        console.log("unreadCount",unreadCount);
                        setNotifcationIMElement(unreadCount);
                        IMElement.setAttribute('notification', unreadCount);
                        document.body.setAttribute('notification', unreadCount);
                        document.body.classList.add('notification');
                    });
                } else {
                    IMElements.forEach((IMElement) => {
                        setNotifcationIMElement(IMElement, 0);
                    });
                    document.body.setAttribute('notification', 0);
                    document.body.classList.remove('notification');
                }
            });
            console.log("countRoom",countRoom);
            console.log("countConversation",countConversation);
        }

        function initializeShowMessageOption(){
            document.addEventListener("click", function(event){
                var targetElement = event.target || event.srcElement;
                if(targetElement.classList.contains("show-message-option")){
                    const converseToolbar = document.querySelector(".bottom-panel");
                    console.log("converseToolbar",converseToolbar.classList);
                    if(converseToolbar.classList.contains("show-message-option-container")){
                        converseToolbar.classList.remove("show-message-option-container");
                    }else {
                        converseToolbar.classList.add("show-message-option-container");
                    }
                }
            });
        }

        function setNotifcationIMElement(value) {
            const IMElement = document.querySelector('.IM');
            if (IMElement) {
            IMElement.setAttribute('notification', value);
            }
        }

        function parseLinkReticularMessage(richText) {
            const message = richText.toString();
            const regex = /reticular:([\-0-9.]+),([\w.]+)/g;
            const matches = message.matchAll(regex);
            const device = document.location.pathname.split('/')[1];
            for (const m of matches) {
                const id = m[1];
                const type = m[2];
                richText.addTemplateResult(
                    m.index,
                    m.index + m[0].length,
                    html`
                        <reticular-link data-href="/${device}/${type}/${id}">lien</reticular-link>`
                );
            }
        }

        const postIdToLink = (post_id) => `reticular:${post_id},post`;

        function sharePost(user_id, post_id) {
            const message = "Cette publication mérite attention : " + postIdToLink(post_id)
            sendMessage(user_id, message);
        }

        function mention(user_id, post_id) {
            const message = "Vous avez été mentionné dans les commentaires d'une publication : " + postIdToLink(post_id);
            sendMessage(user_id, message);
        }

        function sendMessage(user_id, message) {
            const jid = `user-${user_id}@localhost`;

            api.chats.get(jid, [], true).then(chat => {
                chat.maybeShow(true);
                chat.sendMessage({"body": message});
            });
        }

        function setLastOpen(jid) {
            _converse.api.settings.extend({
                lastOpen: jid
            })
        }

        function openLastChat() {
            const jid = _converse.api.settings.get("lastOpen");
            if (jid !== null) {
                api.chats.get(jid, [], true).then(chat => chat.maybeShow(true));
            }
        }

        function closeChat() {
            _converse.api.chats.get().then((data) => {
                const openChat = data.filter((item) => !item.attributes.hidden)[0];
                if (openChat) {
                    api.chats.get(openChat.attributes.id).then((chat) => chat.close());
                    setLastOpen(openChat.attributes.id);
                }
            });
        }

        async function forceRosterRefresh(clear_store) {
            const stack = new Error().stack
            console.log("[conversejs] Force roster refresh", stack);
            if (clear_store) {
                // clearing store is needed to remove deleted profile
                // but it should only be done at initialization otherwise
                // it seems to tamper w/ notification, presences etc.
                await _converse.roster.clearStore();
            }
            await _converse.roster.fetchFromServer();
        }
    },
});
